<div class="ps-large-t mr-large-b">
  <fcom-quick-links [links$]="links$" [showBorder]="false" [showCompact]="true" (clickLink)="clickLink($event)" />
</div>
